/**
 * Extracts the offset from a link
 * @param link - Looks like `/?_filter=&_limit=20&_offset=3`
 * @returns The offset as a number, or undefined if no offset is found
 */
export const extractOffsetFromLink = (
  link: string | undefined,
): number | undefined => {
  if (!link) return undefined;
  // We add a base url to the link so we can make it a valid URL
  // and use searchParams.get to extract the offset
  const url = new URL(link, 'https://doxy.me');
  return url.searchParams.get('_offset')
    ? Number(url.searchParams.get('_offset'))
    : undefined;
};
